var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreatBritain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "gb (4) 1",
    clipPath: "url(#clip0_4765_18652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_18652",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 26.6191C20.1797 26.6191 26 20.7988 26 13.6191C26 6.43944 20.1797 0.619141 13 0.619141C5.8203 0.619141 0 6.43944 0 13.6191C0 20.7988 5.8203 26.6191 13 26.6191Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_18652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 0.619141L0.40625 1.73633L0 2.9043V4.07227L1.625 6.81445L0 9.55664V11.1816L1.625 13.6191L0 16.0566V17.6816L1.625 20.4238L0 23.166V26.6191L1.11719 26.2129L2.28516 26.6191H3.45312L6.19531 24.9941L8.9375 26.6191H10.5625L13 24.9941L15.4375 26.6191H17.0625L19.8047 24.9941L22.5469 26.6191H26L25.5938 25.502L26 24.334V23.166L24.375 20.4238L26 17.6816V16.0566L24.375 13.6191L26 11.1816V9.55664L24.375 6.81445L26 4.07227V0.619141L24.8828 1.02539L23.7148 0.619141H22.5469L19.8047 2.24414L17.0625 0.619141H15.4375L13 2.24414L10.5625 0.619141H8.9375L6.19531 2.24414L3.45312 0.619141H0Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.0625 0.619141V6.10352L22.5469 0.619141H17.0625ZM26 4.07227L20.5156 9.55664H26V4.07227ZM0 9.55664H5.48438L0 4.07227V9.55664ZM3.45312 0.619141L8.9375 6.10352V0.619141H3.45312ZM8.9375 26.6191V21.1348L3.45312 26.6191H8.9375ZM0 23.166L5.48438 17.6816H0V23.166ZM26 17.6816H20.5156L26 23.166V17.6816ZM22.5469 26.6191L17.0625 21.1348V26.6191H22.5469Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 0.619141V2.9043L6.65234 9.55664H8.9375L0 0.619141ZM10.5625 0.619141V11.1816H0V16.0566H10.5625V26.6191H15.4375V16.0566H26V11.1816H15.4375V0.619141H10.5625ZM23.7148 0.619141L17.0625 7.27148V9.55664L26 0.619141H23.7148ZM8.9375 17.6816L0 26.6191H2.28516L8.9375 19.9668V17.6816ZM17.0625 17.6816L26 26.6191V24.334L19.3477 17.6816H17.0625Z",
    fill: "#D80027"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4765_18652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.619141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreatBritain);
export default __webpack_public_path__ + "static/media/great-britain.bc021b2f55d278b522efc0a403d74e06.svg";
export { ForwardRef as ReactComponent };